export default __webpack_public_path__ + "static/login-panel-6c0030531330e634f2559a789cfc7e7a.png";